import { Injectable } from '@angular/core';
import { BaseApiService } from '../base-api.service';
import { CreateRoleDto, Role, RoleForm, UpdateRoleDto } from '../../../../models/role';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class RoleService extends BaseApiService<Role, CreateRoleDto, UpdateRoleDto> {
  constructor(http: HttpClient) {
    super(http);
    this.resourcePath = 'roles';
  }
}
